import React from 'react';
import { mergeRefs } from 'react-laag';

import { useDropdownContext } from './context/DropdownContext';

type RenderFunction = (args: {
  triggerProps: {
    'aria-controls': string;
    'aria-expanded': boolean;
    onClick: (event: React.MouseEvent) => void;
    ref: React.Ref<HTMLButtonElement>;
  };
  isOpen: boolean;
}) => React.ReactElement;

interface Props {
  children:
    | (React.ReactElement & {
        ref?: React.Ref<HTMLButtonElement>;
      })
    | RenderFunction;
}

export const DropdownTrigger = ({ children }: Props) => {
  const { layerProps, menuId, isDropdownOpen, toggleDropdown, triggerRef, isMobile } = useDropdownContext();

  const isRenderFunction = typeof children === 'function';

  const conditionalPopoverRef = isMobile ? null : layerProps.triggerProps.ref;

  const ref = mergeRefs(conditionalPopoverRef, triggerRef, !isRenderFunction && children.ref);

  const onClick = (event: React.MouseEvent) => {
    toggleDropdown();

    if (!isRenderFunction) {
      children.props.onClick?.(event);
    }
  };

  const triggerProps = {
    'aria-controls': menuId,
    'aria-expanded': isDropdownOpen,
    'aria-haspopup': 'menu',
    onClick,
    ref,
  };

  if (isRenderFunction) {
    return children({ isOpen: isDropdownOpen, triggerProps });
  }

  return React.cloneElement(children, triggerProps);
};
